export interface IRecipientProfileHeaderInfo {
    id: number,
    alias: string,
    isTransplanted: boolean,
    isExportable: boolean,
    firstExportableDate: string,
    dateRegistered: string
    isActive: boolean,
    positionInSwap: number,

    histogeneticsRawTypingFile: string,

    clusterId: number,
    clusterNumber: number,
    clusterStatusId: number,
    clusterStatus: string,

    chainId: number,
    chainStatusId: number,
    chainStatus: string,

    lastOrderDate: string,
    validationResults: string[],
    waitListReplaceResults: string[],
    canOrderCheekSwab: boolean,

    dataCompliance: string[],
    adpFormFilePath: string,

    canConvert: boolean,
    canDelete: boolean,
    alleleData: boolean,
    statusId: number,
    typeId: number,
    patientType: string,
    
    matchStatus: number,
    hasMedicareAb: boolean,
    centerHasRecipientShield: boolean,
    recipientShieldEnrolled: boolean,
    voucherDonorId: number,
    voucherDonorAlias: string,
    voucherDonorCenterId: number,
    isWaitlistEligible: boolean,
    requisitionId: number,
    micrositeRecipientId: number,
    location: string
}